module.exports = __webpack_public_path__ + "img/icons/chevron-right.svg";